import { MembershipPlan } from "./schemas";

export enum Feature {
  OfferPage = "OfferPage",
  FancyProfile = "FancyProfile",
  Resources = "Resources",
}

export const hasFeature = (
  coach: { membershipPlan: MembershipPlan },
  feature: Feature,
) => {
  if (feature === Feature.Resources) {
    return true;
  } else if (feature === Feature.OfferPage) {
    return [MembershipPlan.Pro, MembershipPlan.ProPlus].includes(
      coach.membershipPlan,
    );
  } else if (feature === Feature.FancyProfile) {
    return [MembershipPlan.Pro, MembershipPlan.ProPlus].includes(
      coach.membershipPlan,
    );
  }

  return false;
};
